const env = (key) =>
  (window.__ENV__ && window.__ENV__[key]) || process.env[key] || "";

export const REACT_APP_HOST             = env("REACT_APP_HOST");
export const REACT_APP_PORT             = env("REACT_APP_PORT");
export const REACT_APP_SECURE           = env("REACT_APP_SECURE");
export const REACT_APP_EXPRESS_API      = env("REACT_APP_EXPRESS_API");
export const REACT_APP_MAP_SERVER_URL   = env("REACT_APP_MAP_SERVER_URL");
export const REACT_APP_TRIPLE_STORE_URL = env("REACT_APP_TRIPLE_STORE_URL");
export const REACT_APP_AUTH_USERNAME    = env("REACT_APP_AUTH_USERNAME");
export const REACT_APP_AUTH_PASSWORD    = env("REACT_APP_AUTH_PASSWORD");

